import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Bell } from 'react-feather';
import { GET_NOTIFICATIONS } from '../../graphql';
import Notifications from '../../containers/shared/notifications';
import { useLazyQuery } from '@apollo/client';
import { getAuthStateFromToken } from '../../utils/auth';
import { SCREEN } from '../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

const NotificationContainer = styled.div`
  margin-right: 0;
  position: relative;
`;

const RoundRedCounter = styled.div`
  background-color: red;
  border-radius: 6px;
  color: #fff;
  font-size: 0.6em;
  font-weight: 600;
  height: 12px;
  left: 10px;
  padding: 0.5px;
  position: absolute;
  text-align: center;
  top: -4px;
  width: 12px;
`;

const Main = styled('div')`
  font-family: sans-serif;
`;

const DropDownContainer = styled('div')`
  margin-right: 10px;
`;

const DropDownListContainer = styled('div')`
  margin-right: 20px;
  position: absolute;
  z-index: 10000;
  background-color: #3d484a;
  padding-left: 10px;
  padding-right: 10px;
  width: 40%; /* 40% of the parent container's width */
  height: calc((100vh / var(--ib-ui-scale, 1)) - 75pt);
  left: 77%; /* Center horizontally */
  transform: translateX(-50%); /* Center horizontally */
  @media (max-width: 768px) {
    /* Adjustments for screens up to 768px wide */
    width: 80%; /* Modify the width for smaller screens */
  }
`;

const NotificationsDropDown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const container = useRef<HTMLDivElement>(null);
  const toggling = () => setIsOpen(!isOpen);
  const authState = getAuthStateFromToken();

  const [fetchNotifications, { data }] = useLazyQuery(GET_NOTIFICATIONS, {
    variables: {
      input: {
        first: 10,
      },
    },
  });

  const unreadNotifications =
    data && data.notifications && data.notifications.edges.filter((edge: any) => edge.node.read === false);
  const count: number = (unreadNotifications && unreadNotifications.length) || 0;

  useEffect(() => {
    fetchNotifications();
  }, [authState.organisationId, fetchNotifications]);

  useEffect(() => {
    const handleClickOutsideNotificationsDropdown = (event: any) => {
      if (isOpen && !(container.current && container.current.contains(event.target))) {
        toggling();
      }
    };

    document.addEventListener('click', handleClickOutsideNotificationsDropdown);

    return () => {
      document.removeEventListener('click', handleClickOutsideNotificationsDropdown);
    };
  }, [isOpen, toggling]);

  return (
    <Main>
      <DropDownContainer>
        <NotificationContainer onClick={toggling}>
          {count !== 0 && <RoundRedCounter>{count}</RoundRedCounter>}
          <Bell
            {...(isWeb && {
              color: 'white',
            })}
          />
        </NotificationContainer>
        {isOpen && (
          <DropDownListContainer ref={container}>
            <Notifications />
          </DropDownListContainer>
        )}
      </DropDownContainer>
    </Main>
  );
};

export default NotificationsDropDown;
